import { Icon } from "@iconify/react";
import { Button } from "@/shared/components/button";
import { cn } from "@/shared/lib/utils";

interface PageBackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
}

export function PageBackButton({ onClick, ariaLabel = "Go back", className }: PageBackButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={cn(
        // Small white "←" with a thin border that turns brand red on hover.
        "!flex !h-8 !w-8 !shrink-0 !items-center !justify-center !rounded-lg !border !border-[#E5E7EB] !bg-white !p-0 !text-[#0A2947] !shadow-none hover:!border-[#E4002B] hover:!bg-white hover:!text-[#E4002B]",
        className,
      )}
    >
      <Icon icon="lucide:arrow-left" className="h-4 w-4" />
    </Button>
  );
}
